<h3 mat-dialog-title class="text-center">{{ 'Calibration Variability Exceeded' | translate }}</h3>

<mat-dialog-content>
    <p class="breach-summary">
        {{ '{{count}} of the selected samples exceed the configured maximum cal drift.' | translate: { count: data.breaches.length } }}
    </p>

    <table class="breach-table">
        <thead>
            <tr>
                <th>{{ 'Sample Number' | translate }}</th>
                <th>{{ 'Cal Variability' | translate }}</th>
                <th>{{ 'Max Cal Drift' | translate }}</th>
            </tr>
        </thead>
        <tbody>
            @for (breach of data.breaches; track breach.sampleId) {
                <tr>
                    <td class="breach-sample">{{ breach.sampleLabel }}</td>
                    <td class="breach-value">{{ breach.calVariabilityPercent | number: '1.0-2' }}%</td>
                    <td>{{ breach.maxCalDriftPercent | number: '1.0-2' }}%</td>
                </tr>
            }
        </tbody>
    </table>

    <p class="breach-question">{{ 'Do you want to continue the status change for all selected samples, or void the samples listed above?' | translate }}</p>
</mat-dialog-content>

<mat-dialog-actions class="createButton">
    <button class="btn save-modal-btn w-50" (click)="onContinue()">{{ 'Continue' | translate }}</button>
    <button class="btn cancel-modal-btn w-50" (click)="onVoid()">{{ 'Void' | translate }}</button>
</mat-dialog-actions>
